import React from "react";
import { Row, Col, Button } from "antd";
import isFunction from "lodash/isFunction";
import classnames from "classnames";
import WeaInputSearch from "../../wea-input-search";
import WeaLocaleProvider from "../../wea-locale-provider";

const { getLabel } = WeaLocaleProvider;

class Main extends React.Component {
  state = {
    showSearchAd: false
  };
  constructor(props) {
    super(props);
    this.updateState(props);
  }
  componentDidMount() {
    this.updateState();
  }
  componentWillReceiveProps(nextProps) {
    this.updateState(nextProps);
  }
  updateState = props => {
    const { showSearchAd } = props || this.props;
    if (
      showSearchAd !== undefined &&
      this.state.showSearchAd !== showSearchAd
    ) {
      this.setState({ showSearchAd });
    }
  };
  onSearch = v => {
    const { onSearch } = this.props;
    isFunction(onSearch) && onSearch(v);
  };
  onSearchChange = v => {
    const { onSearchChange } = this.props;
    isFunction(onSearchChange) && onSearchChange(v);
  };
  setShowSearchAd = bool => {
    const { setShowSearchAd } = this.props;
    this.setState({ showSearchAd: bool });
    isFunction(setShowSearchAd) && setShowSearchAd(bool);
  };
  render() {
    const { showSearchAd } = this.state;
    const {
      buttonsAd,
      searchsAd,
      searchsBaseValue,
      tabs,
      buttons,
      addSelect,
      searchType,
      height
    } = this.props;
    const searchBase = /base/.test(`${searchType}`);
    const searchAdvanced = /advanced/.test(`${searchType}`);
    const displayStyle = { display: showSearchAd ? "block" : "none" };
    return (
      <div className="wea-tab">
        <Row className="wea-tab-row">
          <Col
            className={classnames({
              "wea-tab-row-left": true,
              "add-select": addSelect,
              "search-base": searchBase,
              "search-advanced": searchAdvanced
            })}
          >
            {tabs}
          </Col>
          <Col
            className={classnames({
              "wea-tab-row-right": true
            })}
          >
            <div className="wea-search-tab">
              {buttons &&
                buttons.map(data => (
                  <span style={{ marginLeft: 15 }}>{data}</span>
                ))}
              {addSelect}
              <div className="advance-search-wrapper">
                {searchBase && (
                  <WeaInputSearch
                    value={searchsBaseValue}
                    onSearch={this.onSearch}
                    onSearchChange={this.onSearchChange}
                  />
                )}
                {searchAdvanced && (
                  <Button
                    type="ghost"
                    className="wea-advanced-search"
                    onClick={() => this.setShowSearchAd(true)}
                  >
                    {getLabel(347, "高级搜索")}
                  </Button>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <div className="wea-search-container" style={displayStyle}>
          <Button
            type="ghost"
            className="wea-advanced-search"
            onClick={() => this.setShowSearchAd(false)}
          >
            {getLabel(347, "高级搜索")}
          </Button>
          <div className="wea-advanced-searchsAd" style={{ maxHeight: height }}>
            {searchsAd}
          </div>
          <div className="wea-search-buttons">
            <div style={{ textAlign: "center" }}>
              {buttonsAd &&
                buttonsAd.map(data => (
                  <span style={{ marginLeft: 15 }}>{data}</span>
                ))}
            </div>
          </div>
        </div>
        <div className="mask-dark" style={displayStyle} />
        <div
          className="mask-wrapper"
          style={displayStyle}
          onClick={() => this.props.hideSearchAd && this.props.hideSearchAd()}
        />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/search/index.js